import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { BackComponent, BackButton, Chevron } from './Back.styles.js';
import  { ReactHtmlParser } from 'helpers/utilities.js';

const Back = ({ label, icon }) => {
  let navigate = useNavigate();
  const goToPreviousPath = () => {
    navigate(-1);
  };
  return (
    <BackComponent>
      <BackButton onClick={goToPreviousPath}>
        <Chevron name={icon} />
        {ReactHtmlParser(label)}
      </BackButton>
    </BackComponent>
  );
};
Back.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};

export default Back;
